import Mock from '@/mocks/Mock'
import Summary, { SummeryItem } from '@/models/Summary'
import { SummaryParams } from '@/repositories/summary-repository'

export default class SummeryMock extends Mock<{ stationId: string; items: SummeryItem }> {
  constructor() {
    super('summery')
  }

  get(params: SummaryParams) {
    console.log(params)

    return new Summary(this.data)
  }
}
